import axios from 'axios'

export const GET_EMPLOYER_USER_SIGNUPS_LOADING = 'employerUserSignupApproval/GET_EMPLOYER_USER_SIGNUPS_LOADING'
export const GET_EMPLOYER_USER_SIGNUPS_SUCCESS = 'employerUserSignupApproval/GET_EMPLOYER_USER_SIGNUPS_SUCCESS'
export const GET_EMPLOYER_USER_SIGNUPS_FAILURE = 'employerUserSignupApproval/GET_EMPLOYER_USER_SIGNUPS_FAILURE'

export const APPROVE_EMPLOYER_USER_SIGNUP_LOADING = 'employerUserSignupApproval/APPROVE_EMPLOYER_USER_SIGNUP_LOADING'
export const APPROVE_EMPLOYER_USER_SIGNUP_SUCCESS = 'employerUserSignupApproval/APPROVE_EMPLOYER_USER_SIGNUP_SUCCESS'
export const APPROVE_EMPLOYER_USER_SIGNUP_FAILURE = 'employerUserSignupApproval/APPROVE_EMPLOYER_USER_SIGNUP_FAILURE'

export const getEmployerUserSignupsLoading = () => ({
  type: GET_EMPLOYER_USER_SIGNUPS_LOADING,
})
export const getEmployerUserSignupsSuccess = payload => ({
  type: GET_EMPLOYER_USER_SIGNUPS_SUCCESS,
  payload,
})
export const getEmployerUserSignupsFailure = payload => ({
  type: GET_EMPLOYER_USER_SIGNUPS_FAILURE,
  payload,
})

export const approveEmployerUserSignupLoading = () => ({
  type: APPROVE_EMPLOYER_USER_SIGNUP_LOADING,
})
export const approveEmployerUserSignupSuccess = payload => ({
  type: APPROVE_EMPLOYER_USER_SIGNUP_SUCCESS,
  payload,
})
export const approveEmployerUserSignupFailure = payload => ({
  type: APPROVE_EMPLOYER_USER_SIGNUP_FAILURE,
  payload,
})

export const fetchEmployerUserSignupListing = () => {
  return async dispatch => {
    dispatch(getEmployerUserSignupsLoading())
    try {
      const response = await axios({
        url: '/api/employer_user_signup_approval',
        method: 'GET',
      })
      dispatch(getEmployerUserSignupsSuccess({ employerUserSignups: response.data }))
    } catch (error) {
      dispatch(getEmployerUserSignupsFailure(error.response))
    }
  }
}

export const fetchApproveEmployerUserSignup = employerUserId => {
  return async dispatch => {
    dispatch(approveEmployerUserSignupLoading())
    try {
      await axios({
        url: '/api/employer_user_signup_approval/approve',
        method: 'POST',
        data: { employerUserId },
      })
      dispatch(approveEmployerUserSignupSuccess({ employerUserId }))
    } catch (error) {
      dispatch(approveEmployerUserSignupFailure(error.response))
    }
  }
}

const initialState = {
  loading: false,
  approving: false,
  employerUserSignups: [],
  errors: [],
}

export const employerUserSignupApprovalReducer = (state = initialState, action) => {
  const { payload } = action

  switch (action.type) {
    case GET_EMPLOYER_USER_SIGNUPS_LOADING:
      return {
        ...state,
        loading: true,
      }
    case GET_EMPLOYER_USER_SIGNUPS_SUCCESS:
      return {
        ...state,
        errors: [],
        loading: false,
        employerUserSignups: payload.employerUserSignups,
      }
    case GET_EMPLOYER_USER_SIGNUPS_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case APPROVE_EMPLOYER_USER_SIGNUP_LOADING:
      return {
        ...state,
        approving: true,
      }
    case APPROVE_EMPLOYER_USER_SIGNUP_SUCCESS:
      return {
        ...state,
        approving: false,
        employerUserSignups: state.employerUserSignups.map(signup =>
          signup.employerUserId === payload.employerUserId
            ? { ...signup, approvedAt: new Date().toISOString(), registrationStatus: 2 }
            : signup,
        ),
      }
    case APPROVE_EMPLOYER_USER_SIGNUP_FAILURE:
      return {
        ...state,
        approving: false,
      }
    default:
      return {
        ...state,
      }
  }
}
